/**
 * CollabSlide Component
 *
 * Renders either a video or a photo inside the phone carousel.
 */

import React from "react";
import SocialVideo from "../SocialVideo";
import * as styles from "./CollabSlide.module.scss";

const CollabSlide = ({ index, video_url, image }) => {
  if (video_url) {
    return <SocialVideo index={index} url={video_url} />;
  }
  if (image?.url) {
    return (
      <div className={styles.wrapper}>
        <img
          src={image.url}
          alt=""
          className={styles.image}
        />
      </div>
    );
  }
  return null;
};

export default CollabSlide;
